export const SET_LOADING    = 'SET_LOADING';
export const SET_ERROR      = 'SET_ERROR';
export const CLEAR_ERROR    = 'CLEAR_ERROR';
export const RESET          = 'RESET';
